import TextField from '@material-ui/core/TextField';
import {
  getIn, useFormikContext,
} from 'formik';
import React, {
  useEffect,
} from 'react';
import FieldError from '../../Utils/FieldError';
import {
  FieldPropsCommon, InputFieldValue,
} from '../types';
import {
  onChange,
} from '../utils';

type Props<T, K extends keyof T> = FieldPropsCommon<T, K> & InputFieldValue<T, K>;

const InputField = <FormModel, FormModelKey extends keyof FormModel>(props: Props<FormModel, FormModelKey>) => {
  const {
    values,
    handleChange,
    errors,
    touched,
    isSubmitting,
    setFieldTouched,
  } = useFormikContext<FormModel>();

  const {
    disabled,
    title,
    location,
  } = props;

  const value: string = getIn(values, location);
  const onValueChange = onChange(handleChange, location);
  const error = getIn(errors, location);
  const isTouched = getIn(touched, location);

  useEffect(() => {
    if (isSubmitting) {
      setFieldTouched(location);
    }
  }, [isSubmitting, location, setFieldTouched]);

  if (!values) {
    return null;
  }

  return (
    <>
      <TextField
        style={{
          margin: 8,
        }}
        value={value}
        variant="outlined"
        disabled={disabled}
        onChange={(e) => {
          onValueChange(e.target.value);
        }}
        onBlur={() => setFieldTouched(location)}
        label={title}
      />
      <FieldError
        errors={error}
        touched={isTouched}
      />
    </>
  );
};

export default InputField;
